var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "xh-stru" }, [
    _vm.headerShow
      ? _c("div", { staticClass: "xh-stru__hd" }, [_vm._v("\n    部门\n  ")])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "xh-stru__bd" },
      [
        _c("el-input", {
          staticClass: "search-input",
          attrs: {
            placeholder: "搜索部门名称",
            size: "small",
            "prefix-icon": "el-icon-search",
          },
          model: {
            value: _vm.searchInput,
            callback: function ($$v) {
              _vm.searchInput = $$v
            },
            expression: "searchInput",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "search-list",
          },
          [
            _c(
              "el-breadcrumb",
              {
                staticStyle: { padding: "5px 0" },
                attrs: { "separator-class": "el-icon-arrow-right" },
              },
              _vm._l(_vm.breadcrumbList, function (item, index) {
                return _c("el-breadcrumb-item", { key: index }, [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function ($event) {
                          return _vm.breadcrumbBtn(item, index)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.label))]
                  ),
                ])
              }),
              1
            ),
            _vm._v(" "),
            _vm._l(_vm.showDataList, function (item, index) {
              return _c(
                "flexbox",
                { key: index, staticClass: "stru-list" },
                [
                  _c("el-checkbox", {
                    staticClass: "stru-check",
                    attrs: { disabled: item.disabled },
                    on: {
                      change: function ($event) {
                        return _vm.checkChange(item, index)
                      },
                    },
                    model: {
                      value: item.isCheck,
                      callback: function ($$v) {
                        _vm.$set(item, "isCheck", $$v)
                      },
                      expression: "item.isCheck",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "stru-name",
                      on: {
                        click: function ($event) {
                          return _vm.enterChildren(item)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item[_vm.props.label]))]
                  ),
                  _vm._v(" "),
                  item.children
                    ? _c("div", {
                        staticClass: "el-icon-arrow-right stru-enter",
                      })
                    : _vm._e(),
                ],
                1
              )
            }),
          ],
          2
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "xh-stru__ft" },
      [
        _c("span", { staticClass: "select-info" }, [
          _vm._v("已选择"),
          _c("span", { staticClass: "select-info--num" }, [
            _vm._v(_vm._s(_vm.value.length)),
          ]),
          _vm._v("项"),
        ]),
        _vm._v(" "),
        _c(
          "el-button",
          { attrs: { type: "text" }, on: { click: _vm.clearAll } },
          [_vm._v("清空")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }